import React from "react";

interface Props {
  className?: string;
}

// Drawn here instead of taken from the icon set: the Material trash is rounder and lighter
// than the squared, heavier outline in the design.
const TrashIcon = ({ className }: Props) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M3.5 6.6h17" />
    <path d="M9.4 6.6V4.9a1 1 0 0 1 1-1h3.2a1 1 0 0 1 1 1v1.7" />
    <path d="M6.3 6.6h11.4v11.9a1.6 1.6 0 0 1-1.6 1.6H7.9a1.6 1.6 0 0 1-1.6-1.6V6.6Z" />
    <path d="M10.3 10.6v5.2" />
    <path d="M13.7 10.6v5.2" />
  </svg>
);

export default TrashIcon;
